import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

import { SubformBaseComponent } from 'src/app/shared/components/subform-base/subform-base.component';

import {
  mainSegmentsWithoutRetailers,
  retailerSegments,
} from '@shared/components/customer-segment-subform/customer-segments';

@Component({
  selector: 'app-product-customer-segment-subform',
  templateUrl: './product-customer-segment-subform.component.html',
  styleUrls: ['./product-customer-segment-subform.component.scss'],
})
export class ProductCustomerSegmentSubformComponent
  extends SubformBaseComponent
  implements OnInit
{
  DICT_PATH = 'PRODUCTS';

  hasRetailerSegmentDisabled = false;

  override ngOnInit(): void {
    super.ngOnInit();
    this.group.setValidators(customerSegmentValidator);
    setTimeout(() => {
      mainSegmentsWithoutRetailers.forEach((segment) => {
        this.group.get(`${segment}Modifiable`)?.value
          ? ''
          : this.group.get(`${segment}`)?.disable();
      });

      retailerSegments.forEach((retailerSegment) => {
        if (
          !this.group.get('retailers')?.get(`${retailerSegment}Modifiable`)
            ?.value
        ) {
          this.group.get('retailers')?.get(`${retailerSegment}`)?.disable();
          this.hasRetailerSegmentDisabled = true;
        }
      });

      this.hasRetailerSegmentDisabled
        ? this.group.get('retailersAllowed')?.disable()
        : '';
    }, 0);
  }

  onValueChange(value: boolean, control: string) {
    if (
      control === 'retailersAllowed' &&
      (!this.isSomeRetailersSelected() ||
        this.isAllRetailersSelected() ||
        !value)
    ) {
      this.group.get('retailers')?.patchValue(
        {
          hotelsAllowed: value,
          restaurantsAllowed: value,
          cafesAllowed: value,
          retailChainsAllowed: value,
          trafiksAllowed: value,
          otherRetailersAllowed: value,
        },
        { emitViewToModelChange: false }
      );
    } else if (!mainSegmentsWithoutRetailers.includes(control)) {
      this.group.controls['retailersAllowed'].setValue(
        this.isSomeRetailersSelected(),
        { emitViewToModelChange: false }
      );
    }
  }

  isSomeRetailersSelected(): boolean {
    const rawValue = this.group.get('retailers')?.getRawValue();
    return Object.keys(rawValue).some(
      (key) => !!rawValue[key] && retailerSegments.includes(key)
    );
  }

  isAllRetailersSelected(): boolean {
    const rawValue = this.group.get('retailers')?.getRawValue();
    return Object.keys(rawValue)
      .filter((property) => !property.includes('Modifiable'))
      .every((key) => !!rawValue[key] && retailerSegments.includes(key));
  }

  get hasError() {
    return this.group.hasError('customerSegment');
  }
}

// check if at least one customer segment is selected
function customerSegmentValidator(customerSegment: AbstractControl) {
  if (
    Object.keys((customerSegment as FormGroup).controls).some(
      (control) =>
        !control.includes('Modifiable') &&
        (customerSegment as FormGroup).controls[`${control}`].value === true
    )
  ) {
    return null;
  } else {
    return { customerSegment: 'no segment selected' };
  }
}
